import React from 'react';
import { useMotivationalMessage } from '../../lib/hooks/useCaptainOverview';

export const MotivationalMessageCard: React.FC = () => {
  const { data: message, isLoading, error } = useMotivationalMessage();

  if (isLoading) {
    return (
      <div className="motivational-card loading">
        <div className="motivational-card-header">
          <div className="icon">💫</div>
          <h2>Daily Inspiration</h2>
        </div>
        <div className="motivational-card-body">
          <div className="skeleton-text skeleton-line"></div>
          <div className="skeleton-text skeleton-line"></div>
        </div>
      </div>
    );
  }

  if (error || !message) {
    return (
      <div className="motivational-card error">
        <div className="motivational-card-header">
          <div className="icon">💫</div>
          <h2>Daily Inspiration</h2>
        </div>
        <div className="motivational-card-body">
          <p className="error-text">Unable to load today's message</p>
        </div>
      </div>
    );
  }

  return (
    <div className="motivational-card">
      <div className="motivational-card-header">
        <div className="icon">💫</div>
        <h2>Daily Inspiration</h2>
      </div>
      <div className="motivational-card-body">
        <blockquote className="quote">
          "{message.message}"
        </blockquote>
        <cite className="author">— {message.author}</cite>
      </div>
    </div>
  );
};
